/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Expenses,
    ExpensesFromJSON,
    ExpensesFromJSONTyped,
    ExpensesToJSON,
    NotificationReceivers,
    NotificationReceiversFromJSON,
    NotificationReceiversFromJSONTyped,
    NotificationReceiversToJSON,
    TaskType,
    TaskTypeFromJSON,
    TaskTypeFromJSONTyped,
    TaskTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface MaintenanceTaskList
 */
export interface MaintenanceTaskList {
    /**
     * 
     * @type {Array<number>}
     * @memberof MaintenanceTaskList
     */
    monitoredObjects?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MaintenanceTaskList
     */
    users?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceTaskList
     */
    clientId: number | null;
    /**
     * 
     * @type {TaskType}
     * @memberof MaintenanceTaskList
     */
    taskType: TaskType;
    /**
     * 
     * @type {Expenses}
     * @memberof MaintenanceTaskList
     */
    expenses?: Expenses;
    /**
     * 
     * @type {Array<NotificationReceivers>}
     * @memberof MaintenanceTaskList
     */
    notificationRecievers?: Array<NotificationReceivers> | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceTaskList
     */
    readonly deleted?: number;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTaskList
     */
    place?: object | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceTaskList
     */
    dueMileageKilometers?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof MaintenanceTaskList
     */
    dueDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceTaskList
     */
    repetitionBindToDueDate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTaskList
     */
    repetitionDueDateType?: MaintenanceTaskListRepetitionDueDateTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceTaskList
     */
    repetitionDueDateValue?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceTaskList
     */
    repetitionDueMileageKilometers?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceTaskList
     */
    notificationDueDateDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceTaskList
     */
    notificationDueMileageKilometers?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof MaintenanceTaskList
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MaintenanceTaskList
     */
    updatedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceTaskList
     */
    lastEvaluationMileage?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof MaintenanceTaskList
     */
    lastEvaluationTimestamp?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MaintenanceTaskList
     */
    completionTime?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceTaskList
     */
    completionMileageKilometers?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTaskList
     */
    notes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTaskList
     */
    contact?: string | null;
}

export function MaintenanceTaskListFromJSON(json: any): MaintenanceTaskList {
    return MaintenanceTaskListFromJSONTyped(json, false);
}

export function MaintenanceTaskListFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaintenanceTaskList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monitoredObjects': !exists(json, 'monitored_objects') ? undefined : json['monitored_objects'],
        'users': !exists(json, 'users') ? undefined : json['users'],
        'clientId': json['client_id'],
        'taskType': TaskTypeFromJSON(json['task_type']),
        'expenses': !exists(json, 'expenses') ? undefined : ExpensesFromJSON(json['expenses']),
        'notificationRecievers': !exists(json, 'notification_recievers') ? undefined : (json['notification_recievers'] === null ? null : (json['notification_recievers'] as Array<any>).map(NotificationReceiversFromJSON)),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'place': !exists(json, 'place') ? undefined : json['place'],
        'dueMileageKilometers': !exists(json, 'due_mileage_kilometers') ? undefined : json['due_mileage_kilometers'],
        'dueDate': !exists(json, 'due_date') ? undefined : (json['due_date'] === null ? null : new Date(json['due_date'])),
        'repetitionBindToDueDate': !exists(json, 'repetition_bind_to_due_date') ? undefined : json['repetition_bind_to_due_date'],
        'repetitionDueDateType': !exists(json, 'repetition_due_date_type') ? undefined : json['repetition_due_date_type'],
        'repetitionDueDateValue': !exists(json, 'repetition_due_date_value') ? undefined : json['repetition_due_date_value'],
        'repetitionDueMileageKilometers': !exists(json, 'repetition_due_mileage_kilometers') ? undefined : json['repetition_due_mileage_kilometers'],
        'notificationDueDateDays': !exists(json, 'notification_due_date_days') ? undefined : json['notification_due_date_days'],
        'notificationDueMileageKilometers': !exists(json, 'notification_due_mileage_kilometers') ? undefined : json['notification_due_mileage_kilometers'],
        'createdAt': !exists(json, 'created_at') ? undefined : (json['created_at'] === null ? null : new Date(json['created_at'])),
        'updatedAt': !exists(json, 'updated_at') ? undefined : (json['updated_at'] === null ? null : new Date(json['updated_at'])),
        'lastEvaluationMileage': !exists(json, 'last_evaluation_mileage') ? undefined : json['last_evaluation_mileage'],
        'lastEvaluationTimestamp': !exists(json, 'last_evaluation_timestamp') ? undefined : (json['last_evaluation_timestamp'] === null ? null : new Date(json['last_evaluation_timestamp'])),
        'completionTime': !exists(json, 'completion_time') ? undefined : (json['completion_time'] === null ? null : new Date(json['completion_time'])),
        'completionMileageKilometers': !exists(json, 'completion_mileage_kilometers') ? undefined : json['completion_mileage_kilometers'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'contact': !exists(json, 'contact') ? undefined : json['contact'],
    };
}

export function MaintenanceTaskListToJSON(value?: MaintenanceTaskList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monitored_objects': value.monitoredObjects,
        'users': value.users,
        'client_id': value.clientId,
        'task_type': TaskTypeToJSON(value.taskType),
        'expenses': ExpensesToJSON(value.expenses),
        'notification_recievers': value.notificationRecievers === undefined ? undefined : (value.notificationRecievers === null ? null : (value.notificationRecievers as Array<any>).map(NotificationReceiversToJSON)),
        'place': value.place,
        'due_mileage_kilometers': value.dueMileageKilometers,
        'due_date': value.dueDate === undefined ? undefined : (value.dueDate === null ? null : value.dueDate.toISOString()),
        'repetition_bind_to_due_date': value.repetitionBindToDueDate,
        'repetition_due_date_type': value.repetitionDueDateType,
        'repetition_due_date_value': value.repetitionDueDateValue,
        'repetition_due_mileage_kilometers': value.repetitionDueMileageKilometers,
        'notification_due_date_days': value.notificationDueDateDays,
        'notification_due_mileage_kilometers': value.notificationDueMileageKilometers,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt === null ? null : value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt === null ? null : value.updatedAt.toISOString()),
        'last_evaluation_mileage': value.lastEvaluationMileage,
        'last_evaluation_timestamp': value.lastEvaluationTimestamp === undefined ? undefined : (value.lastEvaluationTimestamp === null ? null : value.lastEvaluationTimestamp.toISOString()),
        'completion_time': value.completionTime === undefined ? undefined : (value.completionTime === null ? null : value.completionTime.toISOString()),
        'completion_mileage_kilometers': value.completionMileageKilometers,
        'notes': value.notes,
        'contact': value.contact,
    };
}

/**
* @export
* @enum {string}
*/
export enum MaintenanceTaskListRepetitionDueDateTypeEnum {
    Day = 'day',
    Week = 'week',
    Month = 'month',
    Year = 'year'
}


